(ns web3.auth.auth0
  (:require ["@auth0/auth0-spa-js" :as auth0]
            [web3.errors :as err]
            [web3.env :as env]
            [web3.utils :as utils :include-macros true]
            [web3.persistence.local :as local]
            [web3.re-frame.interceptors :as intr]
            [web3.routing.core :as routing]
            [web3.tracking.ga :as ga]
            [re-frame.core :as rf]
            [day8.re-frame.async-flow-fx]
            [re-frame-simple.db :as db]
            [clojure.spec.alpha :as s]
            [clojure.string :as str]
            [web3.log :as log]
            [web3.routing.utils :as ru]
            [applied-science.js-interop :as j]
            [kitchen-async.promise :as p]
            [web3.tracking.segment :as seg]
            [web3.tracking.mixpanel :as mix]))

(defn js-call-promise [o path & args ]
  (p/promise [resolve reject]
             (apply j/call-in o path (conj (vec args)
                                           (fn [err value]
                                             (if err (reject err)
                                                     (resolve value)))))))

;; ========== init =============
(js/goog.exportSymbol "@auth0/auth0-spa-js" auth0)

(def auth0-widget-element "#osw")

(defonce ^js web-auth (atom nil))

(s/def ::baseUrl string?)
(s/def ::params (s/keys :req-un [::baseUrl]))


;; ========== Auth0 API ===========
(defn current-time []
  (.getTime (js/Date.)))

(defn handle-auth-error [error]
  (log/println :debug :<auth-callback/error error)
  (rf/dispatch [:events/handle-error
                {:source :auth0/error
                 :error error
                 :dispatch [:error/auth.invalid error]}]))

(def analytics-ready
  (p/promisify #(j/call-in js/window [:analytics :ready] %)))

(defn get-mixpanel-id []
  (when (:SEGMENT_ID env/config)
    (p/do (analytics-ready)
          (mix/get-distinct-id))))

(defn login!
  []
  (let [web-auth-local (local/local-get :auth0/web-auth-local)]
    (log/info "In Login")
    (p/let [ga-auth (ga/event! "authorize")
            tracking-id (p/race [(p/timeout 2000)
                                 (get-mixpanel-id)])]
           (log/info "auth0 instance in login is: " @web-auth)
           (log/info "auth0 instance in login from local is: " web-auth-local)
           (if (or @web-auth web-auth-local)
             (do (j/call (or @web-auth web-auth-local) :loginWithRedirect
                         (clj->js {:redirect_uri (:AUTH0_REDIRECT_URL env/config)}))
                 (log/info "Login: Get With Redirect Called"))
             (do (log/println "reloading as auth0 instance not found due to session expiration, cookies will expire now")
                 (rf/dispatch-sync [:do/auth.redirect]))))))

(defn logout!
  []
  (let [remove-item! #(j/call (j/get js/window :localStorage)
                              :removeItem %)
        web-auth-local (local/local-get :auth0/web-auth-local)]
    (log/info "In logout")
    (log/info "auth0 instance in logout is: " @web-auth)
    (log/info "auth0 instance in logout from local is: " web-auth-local)
    (-> (j/call (or @web-auth web-auth-local) :logout
                (clj->js {:returnTo (:AUTH0_LOGOUT_REDIRECT_URL env/config)}))
        (p/then #(do (log/info "Logout: In catch")
                     (j/call-in @web-auth [:authClient :tokenManager :clear])
                     (mapv remove-item! ["auth0-cache-storage"
                                         "auth0-token-storage"
                                         "auth0-pkce-storage"])
                     (log/info "Logout: Cleared cookies and token manager")
                     (.assign js/location (.. js/window -location -origin))))
        (p/catch* #(do (log/info "Logout: In catch")
                       (j/call-in @web-auth [:authClient :tokenManager :clear])
                       (mapv remove-item! ["auth0-cache-storage"
                                           "auth0-token-storage"
                                           "auth0-pkce-storage"])
                       (log/info "In logout: Cleared cookies and token manager")
                       (.assign js/location (.. js/window -location -origin)))))
    (p/do (p/timeout 5000)
          (local/local-dissoc! :auth0/web-auth-local))))

(defn expires-at
  [auth]
  (-> auth
      :expires-in
      (* 1000)
      (+ (current-time))))

(defn expired?
  [auth]
  (not (some-> auth
               :expires-at
               (> (current-time)))))

(defn until-expire
  [auth]
  (some-> auth
          :expires-at
          (* 1000)
          (- (current-time))))

(defn renew-in
  [auth]
  (- (until-expire auth) 0))

(defn renew?
  [auth]
  (<= (renew-in auth) 0))

(defn redirect-path
  []
  (let [path (if (some #(= (ru/get-route)
                           (routing/path-for [%]))
                       [:logout :authorize])
               (routing/path-for [:home])
               (ru/get-route))]
    (log/println :debug "save :auth0/redirect" path)
    path))
(defn redirect! [loc]
  (set! (.-location js/window) loc))

;; ========== Async Flow ==========
(defn handle-signup []
  (let  [query js/window.location.search
         query (str/replace query  "?"  "")
         queryArr (str/split query #"&")
         ]
    ;query js/window.location.search
    ;     _ (when (and (str/includes? query "code=")
    ;                  (str/includes? query "state=") )
    (log/println ":: error received ::" query queryArr  )
    (redirect! (str "/signup-complete?" query) )
    )
  )

(defn get-param-value  [name]
  (nth (str/split name #"=") 1)
  )
(def auth-flow
  {:id :auth-flow
   :db-path [:async-flows :auth]
   :first-dispatch [:do/auth.init]
   :rules [{:when :seen-any-of?
            :events [:error/auth.invalid]
            ;:dispatch [:do/auth.sign-in]
            :halt? true}
           {:when :seen-any-of?
            :events [:error/auth.soft-renew-failed]
            :halt? true}
           {:when :seen-all-of?
            :events [:do/auth.authorize
                     :do/auth.set
                     :do/auth.set-user]
            :dispatch [:do/auth.redirect]}
           {:when :seen?
            :events [:do/auth.redirect]
            :dispatch [:success/auth]
            :halt? true}
           {:when :seen-all-of?
            :events [:do/auth.renew
                     :do/auth.set
                     :do/auth.set-user]
            :dispatch [:success/auth]
            :halt? true}]})

;; {:domain "sky-test.us.auth0.com"
;                        :client_id "gdb4g8AygQL22giW6ueiX5gLV7Jbhscv"
;                        :useRefreshTokens true}

;; homeserve-nonprod.us.auth0.com, esnBLSdlE9ouIQHsU1qUZVfNykYSTDSD,
;; hYa2rNpKYYVd3g-_L1cyMlq4IVDfPOm5xjgVdLZ8l1ehnzZDGRCXRo9MAQF0sWne

(defn initialize-auth0-client!
  []

  ;; ========== FX ==========

  (rf/reg-fx
    :auth0/authorize
    (fn []
      (p/do (p/timeout 0)
            (login!))))

  (rf/reg-fx
    :auth0/logout
    (fn [_]
      (p/do (p/timeout 0)
            (logout!))))

  (rf/reg-fx
    :auth/get-user
    (fn [_]
      (p/try (p/let [user (j/call @web-auth :getUser)]
                    (log/info :auth/get-user user)
                    (rf/dispatch [:do/auth.set-user (utils/->clj-map user)]))
             (p/catch :default e
               (handle-auth-error e)))))
  (rf/reg-fx
    :auth/set-renew-timer
    (fn [auth]
      (log/println :debug :auth/set-renew-timer (renew-in auth))
      (log/time-end :debug "auth-flow")
      (log/group-end :debug)

      (p/do (p/timeout (renew-in auth))
            (log/println :debug :auth/set-renew-timer auth)
            (rf/dispatch [:do/auth.start-flow]))))

  ;; ========== Events ==========

  (intr/reg-event-fx
    :do/auth.logout
    [log/interceptor]
    (fn [cofx _]
      {:local/dissoc [:auth0/auth :auth0/profile :auth0/redirect]
       ::seg/logout nil
       :branch.io/logout nil
       :intercom/shutdown nil
       :auth0/logout nil}))

  ;; AFAIK this is just an blank event, used by the re-frame-async auth-flow
  (intr/reg-event-fx :error/auth.invalid (fn [_ _]))

  (intr/reg-event-fx :error/auth.soft-renew-failed
                     (fn [{:keys [db]} _]
                       {:db (assoc db :auth0/loading? false)}))

  (intr/reg-event-fx
    :do/auth.sign-in
    [log/interceptor]
    (fn [cofx _]
      (log/println "the redirect path is: " (redirect-path))
      {:local/assoc {:auth0/redirect (redirect-path)
                     :document/referrer (.-referrer js/document)}
       :auth0/authorize nil}))

  (intr/reg-event-fx
    :do/auth.set-user
    [log/interceptor]
    (fn [db [_ profile]]
      (log/println "in set-user with profile " profile)
      {:local/assoc {:auth0/profile profile}}))

  (intr/reg-event-fx
    :do/auth.set
    [log/interceptor]
    (fn [{:keys [db]} [_ auth]]
      (log/info :do/auth.set auth)
      (log/info  auth )
      (log/info (:access-token auth))
      (let [bearer-token (.-__raw (:id-token auth))
            ;changed auth (merge auth {:access-token bearer-token})
            access-token (:access-token auth)
            auth (merge auth {:access-token access-token})
            id-token (:id-token auth)
            expiry (.-exp (:id-token auth))
            _ (log/println "the expiry of current access token is: " expiry)
            auth (zipmap [:id-token :access-token :expires-at]
                         [id-token access-token expiry])]
        {:local/assoc {:auth0/auth auth}
         :auth/get-user nil})))

  (intr/reg-event-fx
    :do/auth.redirect
    [(rf/inject-cofx :local/get :auth0/redirect)
     log/interceptor]
    (fn [{:keys [auth0/redirect]} [_]]
      (log/println :info "load: auth0/redirect" redirect)
      {:history/replace redirect}))

  (intr/reg-event-fx
    :do/auth.authorize
    [log/interceptor
     (rf/inject-cofx :local/get :document/referrer)
     (rf/inject-cofx :local/get :auth0/web-auth-local)]
    (fn [{:keys [db document/referrer auth0/web-auth-local]} _]
      (let []
        (do
          (log/println :do/auth.authorize-start)
          (if (str/includes? js/window.location.search "error=new_user")
            (handle-signup)
            (log/println ":: error not received ::")
            )
          (p/try
            (log/println "auth0 instance in authorize start is: " @web-auth)
            (log/println "auth0 instance from cache in authorize start is: " web-auth-local)
            (p/let [query js/window.location.search
                    _ (log/println "the query params are: " query)
                    _ (when (and (str/includes? query "code=")
                                 (str/includes? query "state="))
                        (log/println "going to call handle redirect callback, time:" (current-time))
                        (p/try
                          (j/call (or @web-auth web-auth-local) :handleRedirectCallback)
                          (p/catch :default e
                            (log/println "error in handling redirect callback" e "time: " (current-time))
                            (p/timeout 5000)
                            (log/println "timeout over, calling redirect callback handle second time: " @web-auth "time: " (current-time))
                            (j/call (or @web-auth web-auth-local) :handleRedirectCallback))))
                    access-token (j/call (or @web-auth web-auth-local) :getTokenSilently)
                    ;access-refresh-token (j/call (or @web-auth web-auth-local) :getAccessTokenSilently)
                    id-token (js->clj (j/call (or @web-auth web-auth-local) :getIdTokenClaims))
                    bearer-token (.-__raw id-token)
                    ;bearer-token (:access-token auth)
                    auth-data {:access-token access-token
                               :id-token id-token
                               :check-token bearer-token
                               }]
                   (log/println :do/auth.authorize-data auth-data)
                   (rf/dispatch [:do/auth.set auth-data]))
            (p/catch :default e
              (handle-auth-error e)
              ;; Think of displaying refresh page message here
              (rf/dispatch-sync [:do/auth.sign-in]))))
        {:db (assoc db :document/referrer referrer)})))

  (intr/reg-event-fx
    :do/auth.renew
    [(rf/inject-cofx :local/get :auth0/auth)
     (rf/inject-cofx :local/get :auth0/web-auth-local)
     log/interceptor]
    (fn [{:keys [auth0/auth auth0/web-auth-local db]} [_ {:keys [on-error]
                                                          :or {on-error handle-auth-error}}]]
      (let [start (atom (current-time))]
        (log/println :do/auth.renew-start)
        (log/println "auth0 instance in renew start is: " @web-auth)
        (log/println "auth0 instance from cache in renew start is: " web-auth-local)
        (p/try
          (p/let [access-token (j/call (or @web-auth web-auth-local) :getTokenSilently)
                  _ (log/println "silently renewed token is: " access-token)
                  id-token (js->clj (j/call (or @web-auth web-auth-local) :getIdTokenClaims))
                  auth-data {:access-token access-token
                             :id-token id-token}]
                 (log/println :do/auth.renew auth-data)
                 (rf/dispatch [:do/auth.set (assoc auth :access-token access-token
                                                        :id-token id-token)]))
          (p/catch :default e
            (handle-auth-error e)
            (log/println "auth expired, triggering reauth, redirect path is: " (redirect-path))
            ;{:local/assoc {:auth0/redirect (redirect-path)
            ;               :document/referrer (.-referrer js/document)}
            ; :auth0/authorize nil}
            ;; Think of displaying refresh page message here
            (rf/dispatch-sync [:do/auth.sign-in])))
        {})))

  (intr/reg-event-fx
    :do/auth.init
    [(rf/inject-cofx :local/get :auth0/auth)
     (rf/inject-cofx :local/get :auth0/profile)
     log/interceptor]
    (fn [{:keys [auth0/auth auth0/profile db]} [_ {:keys [auth-mode]
                                                   :or {auth-mode :ensure-auth}}]]

      ;; auth-mode can be one of:
      ;;   :renew-softly          only refresh an existing token (silently), never redirect user from page
      ;;   :force-refresh         assume that local token is invalid, forces refresh
      ;;   :ensure-auth (default) ensure that user is authed, refreshing token or redirecting to sign-in/sign-up page
      (log/println "auth flow init" auth auth-mode)
      (log/println :info {:auth-mode auth-mode
                          :auth? (boolean auth)
                          :renew? (renew? auth)
                          :path js/window.location.pathname
                          :auth [(local/local-get :auth0/auth)]
                          :root-handler (db/get-in [:db/routers :router/root :handler])})

      {:dispatch (cond
                   (= (db/get-in [:db/routers :router/root :handler]) :authorize) [:do/auth.authorize]
                   (= auth-mode :renew-softly) [:do/auth.renew {:on-error #(rf/dispatch [:error/auth.soft-renew-failed])}]
                   (not auth) [:do/auth.sign-in]
                   (or (= auth-mode :force-refresh)
                       (renew? auth)) [:do/auth.renew]
                   :else [:success/auth])
       :db (if-not (= auth-mode :renew-softly)
             (assoc db :auth0/loading? true)
             db)}))

  ;; ========== For coordinating fx ==========

  (rf/reg-fx
    :after
    (fn [fx]
      (rf/dispatch [:do/after fx])))

  (rf/reg-event-fx
    :do/after
    (fn [cofx [_ fx]]
      fx))

  ;; register this event just to avoid warnings
  (intr/reg-event-fx :do/auth.require-auth (fn []))

  (intr/reg-event-fx
    :do/auth.start-flow
    (fn [_ [_ auth-init-options]]
      (log/println :do/auth.start-flow auth-init-options)
      (log/time-start :debug "auth-flow")
      (log/group-start-collapsed :debug "🔑 Auth Flow")
      {:async-flow (-> auth-flow
                       (update :first-dispatch conj auth-init-options))}))

  (intr/reg-event-fx
    :success/auth
    [(rf/inject-cofx :local/get :auth0/auth)
     (rf/inject-cofx :local/get :auth0/profile)
     log/interceptor]
    (fn [{:keys [db auth0/auth auth0/profile]} _]
      {:auth/set-renew-timer auth
       :branch.io/set-identity (:email profile)
       :sentry/set-user-context (:email profile)
       :facebook.pixel/init profile
       :hubspot/init profile
       :db (assoc db
             :auth0/auth auth
             :auth0/profile profile
             :auth0/loaded? true
             :auth0/loading? false)
       :after {:graphql/retry-errored-queries nil
               :web3.tracking.segment/init nil}}))

  (swap! intr/mixpanel-blacklist into [:do/auth.init :do/auth.require-auth]))

(defn init-auth-fx []
  (initialize-auth0-client!)


  (p/try (-> (auth0. (clj->js {:domain (:domain  (:AUTH0_CONFIG env/config) )
                               :client_id (:client_id  (:AUTH0_CONFIG env/config) )
                               :audience (:audience  (:AUTH0_CONFIG env/config) )
                               :useRefreshTokens true}))
             (p/then #(do (reset! web-auth %)
                          ;(local/local-assoc! :auth0/web-auth-local %)
                          ;(log/println "auth0 instance saved in local cache is: " (local/local-get :auth0/web-auth-local))
                          (log/println "auth0 instance is:" %))))
         (p/catch :default e (log/println "init-auth-fx error: In catch" e))))